import React from "react";
import { Route, Routes } from "react-router-dom";
import PublicLayout from "../components/layouts/public/PublicLayout";
import LoginView from "../screens/login/LoginView";
import UnauthorizedAccess from "../screens/unauthorized-access/UnauthorizedAccess";
import VerifyOTP from "../screens/verify-otp/verifyOtp";
import ForgotPassword from "../screens/forgot-password/ForgotPassword";
import ResetPassword from "../screens/reset-password/ResetPassword";

const PublicRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route path={routePublic.login} element={<LoginView />} />
        <Route path={routePublic.verifyOtp} element={<VerifyOTP />} />
        <Route path={routePublic.forgotPassword} element={<ForgotPassword />} />
        <Route path={routePublic.resetPassword} element={<ResetPassword />} />
        <Route
          path={routePublic.unauthorizedAccess}
          element={<UnauthorizedAccess />}
        />
      </Route>
    </Routes>
  );
};

export default PublicRouter;

export const routePublic = {
  login: "log-in",
  unauthorizedAccess: "unauthorizedAccess",
  verifyOtp: "verify-otp",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
};
